import { render, staticRenderFns } from "./registro-movimiento.vue?vue&type=template&id=2de303a6&"
import script from "./registro-movimiento.component.ts?vue&type=script&lang=ts&"
export * from "./registro-movimiento.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports